module.exports = __webpack_public_path__ + "static/media/sell_finish_service_rent_2.63571b38.jpg";